import React from "react";
import ArticleForm from "../components/ArticleForm";
import { COLLECTIONS } from "../utils/cmsSchema";

export default function BlogForm() {
  return (
    <ArticleForm
      schema={COLLECTIONS.blogs}
      backLabel="Back to Blogs"
      eyebrowSingular="Blog"
    />
  );
}
